/***
 * 로그인 여부 저장
 */

import { create } from "zustand";
import { persist, type PersistStorage } from "zustand/middleware";

interface SetLoginState {
  isLogin: boolean;
  setIsLogin: (value: boolean) => void;
}

// 세션 스토리지 래퍼
const sessionStorageWrapper: PersistStorage<Pick<SetLoginState, "isLogin">> = {
  getItem: (name: string) => {
    const isLogin = sessionStorage.getItem(name);
    if (isLogin) {
      return JSON.parse(isLogin);
    }
    return null;
  },
  setItem: (name, value) =>
    Promise.resolve(sessionStorage.setItem(name, JSON.stringify(value))),
  removeItem: (name: string): void => sessionStorage.removeItem(name),
};

const useAuthStore = create<SetLoginState>()(
  persist(
    (set) => ({
      isLogin: false,

      // 로그인 후 로그인 상태 저장
      setIsLogin: (value: boolean) => {
        set({ isLogin: value });
      },
    }),
    {
      name: "isLogin-session",
      storage: sessionStorageWrapper,
      partialize: (state) => ({ isLogin: state.isLogin }), // optional
    }
  )
);

export default useAuthStore;
